import { breakpoints, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  padding: 0 16px;
  gap: 20px;

  @media ${breakpoints.sm} {
    width: 580px;
  }

  @media ${breakpoints.lg} {
    width: 554px;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  flex-basis: 45%;
  align-items: center;
  @media ${breakpoints.lg} {
    flex-basis: 40%;
  }

  @media ${breakpoints.lg} and (max-height: 880px) {
    flex-basis: 45%;
  }
`;

export const Title = styled.h1`
  text-align: center;
  ${typographyV2.title3XL};
  color: var(--surface-primary);
  display: flex;
  flex-direction: column;

  & span {
    display: inline-flex;
  }

  & mark {
    font-size: 10px;
    line-height: 1rem;
    color: inherit;
    background-color: inherit;
  }
`;

export const Subtitle = styled.span`
  ${typographyV2.title2XL};
  color: var(--text-default);
`;
